import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_PAYMENT_CARDS: MijnRoute = {
    path: 'betaalpassen',
    navigationEvent: 'toBetaalpassen',
    regex: /^\/zelf-regelen\/betaalpassen$/,
    webcomponent: 'mijn-klant-betaalpassen-webcomponent'
};
